import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap } from 'rxjs';
import { libraryActions } from '../actions/library.actions';
import { HttpService } from '../services/http.service';
import { finalizeLoader } from '@app/shared';

@Injectable()
export class LibraryEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getLibrary$ = createEffect(() => {
        return this.actions.pipe(
            ofType(libraryActions.getLibrary),
            mergeMap(({ pathId }) => {
                return this.httpService.getLibrary(pathId).pipe(
                    finalizeLoader('library-get'),
                    map((courses) => libraryActions.getLibrarySuccess({ courses })),
                    catchError(() => of(libraryActions.getLibraryError())),
                );
            }),
        );
    });
}
